import { lazy, Suspense } from 'react'
import type { ComponentProps } from 'react'
import type CreateSimLaunchFormInner from '@/components/CreateSimLaunchForm'

/**
 * Client-only boundary for the curve create form.
 *
 * `CreateSimLaunchForm` imports `useCurveWrites`, which statically imports
 * `wagmi`. That graph reaches WalletConnect's `jsonrpc-ws-connection`, whose
 * `require("ws")` fallback breaks the Node/ESM prerender pass with
 * `ReferenceError: require is not defined in ES module scope`.
 *
 * Keeping the real form behind `lazy()` means the prerender entry never
 * evaluates wagmi/WalletConnect, while the browser still loads the full form.
 *
 * DO NOT convert this back into a static import.
 */
const CreateSimLaunchForm = lazy(() => import('@/components/CreateSimLaunchForm'))

type CreateSimLaunchFormLazyProps = ComponentProps<typeof CreateSimLaunchFormInner>

function CreateSimLaunchFormLazy(props: CreateSimLaunchFormLazyProps) {
  return (
    <Suspense
      fallback={(
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 text-sm text-zinc-400 backdrop-blur-md">
          Loading launch form…
        </div>
      )}
    >
      <CreateSimLaunchForm {...props} />
    </Suspense>
  )
}

export default CreateSimLaunchFormLazy
